module.exports = __webpack_public_path__ + "static/img/img_0434.4d0648f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0434.jpg
// module id = 65uq
// module chunks = 0